const scaleRating = (rtg: number, [start = 1, end = 5] = []) => {
  if (!Number.isFinite(rtg)) return undefined;
  return (end - start) * rtg + start;
};

// eslint-disable-next-line import/prefer-default-export
export { scaleRating };
